export const isValidField = (fieldName) => {
  const field = document.getElementsByName(fieldName)[0];
  return field ? field.validity.valid : false;
};
